/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminSearchConfiguration,
  CreateSearchConfigRequest,
  CreateSearchConfigResponse,
  ErrorResponse,
  SearchCollectionsResponse,
  SearchOverridesResponse,
  SearchResultPage,
  UpsertSearchOverride,
} from '../models/index';
import {
    AdminSearchConfigurationFromJSON,
    AdminSearchConfigurationToJSON,
    CreateSearchConfigRequestFromJSON,
    CreateSearchConfigRequestToJSON,
    CreateSearchConfigResponseFromJSON,
    CreateSearchConfigResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SearchCollectionsResponseFromJSON,
    SearchCollectionsResponseToJSON,
    SearchOverridesResponseFromJSON,
    SearchOverridesResponseToJSON,
    SearchResultPageFromJSON,
    SearchResultPageToJSON,
    UpsertSearchOverrideFromJSON,
    UpsertSearchOverrideToJSON,
} from '../models/index';

export interface CreateSearchConfigOperationRequest {
    customerId: string;
    createSearchConfigRequest: CreateSearchConfigRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteSearchOverrideRequest {
    overrideName: string;
    hostname: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSearchCollectionsRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSearchConfigRequest {
    hostname: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSearchOverridesRequest {
    hostname: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface QueryCollectionRequest {
    hostname: string;
    fieldName: string;
    searchTerm: string;
    customerId: string;
    page?: number;
    pageSize?: number;
    xClientID?: string;
    xRequestID?: string;
}

export interface SaveSearchConfigRequest {
    hostname: string;
    customerId: string;
    adminSearchConfiguration: AdminSearchConfiguration;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpsertSearchOverrideRequest {
    customerId: string;
    upsertSearchOverride: UpsertSearchOverride;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * Create a new search config. The `encodedAnalyticsKey` is minted server-side as a PDS API key with the ANALYTICS scope and returned once in this response — it cannot be retrieved later, so the caller must save it before the response is discarded.
     */
    async createSearchConfigRaw(requestParameters: CreateSearchConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSearchConfigResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createSearchConfig().'
            );
        }

        if (requestParameters['createSearchConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'createSearchConfigRequest',
                'Required parameter "createSearchConfigRequest" was null or undefined when calling createSearchConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSearchConfigRequestToJSON(requestParameters['createSearchConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchConfigResponseFromJSON(jsonValue));
    }

    /**
     * Create a new search config. The `encodedAnalyticsKey` is minted server-side as a PDS API key with the ANALYTICS scope and returned once in this response — it cannot be retrieved later, so the caller must save it before the response is discarded.
     */
    async createSearchConfig(requestParameters: CreateSearchConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSearchConfigResponse> {
        const response = await this.createSearchConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a search override rule
     */
    async deleteSearchOverrideRaw(requestParameters: DeleteSearchOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['overrideName'] == null) {
            throw new runtime.RequiredError(
                'overrideName',
                'Required parameter "overrideName" was null or undefined when calling deleteSearchOverride().'
            );
        }

        if (requestParameters['hostname'] == null) {
            throw new runtime.RequiredError(
                'hostname',
                'Required parameter "hostname" was null or undefined when calling deleteSearchOverride().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteSearchOverride().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration/{hostname}/override/{overrideName}`;
        urlPath = urlPath.replace(`{${"overrideName"}}`, encodeURIComponent(String(requestParameters['overrideName'])));
        urlPath = urlPath.replace(`{${"hostname"}}`, encodeURIComponent(String(requestParameters['hostname'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a search override rule
     */
    async deleteSearchOverride(requestParameters: DeleteSearchOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSearchOverrideRaw(requestParameters, initOverrides);
    }

    /**
     * Get all collections available to a customer
     */
    async getSearchCollectionsRaw(requestParameters: GetSearchCollectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchCollectionsResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSearchCollections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/collections`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchCollectionsResponseFromJSON(jsonValue));
    }

    /**
     * Get all collections available to a customer
     */
    async getSearchCollections(requestParameters: GetSearchCollectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchCollectionsResponse> {
        const response = await this.getSearchCollectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get admin search config
     */
    async getSearchConfigRaw(requestParameters: GetSearchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminSearchConfiguration>> {
        if (requestParameters['hostname'] == null) {
            throw new runtime.RequiredError(
                'hostname',
                'Required parameter "hostname" was null or undefined when calling getSearchConfig().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSearchConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hostname'] != null) {
            queryParameters['hostname'] = requestParameters['hostname'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminSearchConfigurationFromJSON(jsonValue));
    }

    /**
     * Get admin search config
     */
    async getSearchConfig(requestParameters: GetSearchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminSearchConfiguration> {
        const response = await this.getSearchConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all search overrides
     */
    async getSearchOverridesRaw(requestParameters: GetSearchOverridesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchOverridesResponse>> {
        if (requestParameters['hostname'] == null) {
            throw new runtime.RequiredError(
                'hostname',
                'Required parameter "hostname" was null or undefined when calling getSearchOverrides().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSearchOverrides().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hostname'] != null) {
            queryParameters['hostname'] = requestParameters['hostname'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration/overrides`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchOverridesResponseFromJSON(jsonValue));
    }

    /**
     * Get all search overrides
     */
    async getSearchOverrides(requestParameters: GetSearchOverridesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchOverridesResponse> {
        const response = await this.getSearchOverridesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for documents in a collection. Allows a field to query against and returns paginated results
     */
    async queryCollectionRaw(requestParameters: QueryCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultPage>> {
        if (requestParameters['hostname'] == null) {
            throw new runtime.RequiredError(
                'hostname',
                'Required parameter "hostname" was null or undefined when calling queryCollection().'
            );
        }

        if (requestParameters['fieldName'] == null) {
            throw new runtime.RequiredError(
                'fieldName',
                'Required parameter "fieldName" was null or undefined when calling queryCollection().'
            );
        }

        if (requestParameters['searchTerm'] == null) {
            throw new runtime.RequiredError(
                'searchTerm',
                'Required parameter "searchTerm" was null or undefined when calling queryCollection().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling queryCollection().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hostname'] != null) {
            queryParameters['hostname'] = requestParameters['hostname'];
        }

        if (requestParameters['fieldName'] != null) {
            queryParameters['fieldName'] = requestParameters['fieldName'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultPageFromJSON(jsonValue));
    }

    /**
     * Search for documents in a collection. Allows a field to query against and returns paginated results
     */
    async queryCollection(requestParameters: QueryCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultPage> {
        const response = await this.queryCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit admin search config
     */
    async saveSearchConfigRaw(requestParameters: SaveSearchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['hostname'] == null) {
            throw new runtime.RequiredError(
                'hostname',
                'Required parameter "hostname" was null or undefined when calling saveSearchConfig().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling saveSearchConfig().'
            );
        }

        if (requestParameters['adminSearchConfiguration'] == null) {
            throw new runtime.RequiredError(
                'adminSearchConfiguration',
                'Required parameter "adminSearchConfiguration" was null or undefined when calling saveSearchConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['hostname'] != null) {
            queryParameters['hostname'] = requestParameters['hostname'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AdminSearchConfigurationToJSON(requestParameters['adminSearchConfiguration']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Edit admin search config
     */
    async saveSearchConfig(requestParameters: SaveSearchConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveSearchConfigRaw(requestParameters, initOverrides);
    }

    /**
     * Create a search override rule
     */
    async upsertSearchOverrideRaw(requestParameters: UpsertSearchOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling upsertSearchOverride().'
            );
        }

        if (requestParameters['upsertSearchOverride'] == null) {
            throw new runtime.RequiredError(
                'upsertSearchOverride',
                'Required parameter "upsertSearchOverride" was null or undefined when calling upsertSearchOverride().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:search"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/search/configuration/override`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertSearchOverrideToJSON(requestParameters['upsertSearchOverride']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a search override rule
     */
    async upsertSearchOverride(requestParameters: UpsertSearchOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertSearchOverrideRaw(requestParameters, initOverrides);
    }

}
